export default {
  methods: {
    parseDefaultPromotionData(promotion) {

    }
  }
}
